import { Helpers } from '../../helpers';
import { IScheduleTemplateName } from '../../interfaces/ischedule-template-name';
import { ProjectTemplate } from '../project-template';
import { Schedule } from '../schedule';
import { ScheduleWBSs } from '../schedule-w-b-ss';
import { ScheduleWbsTemplate } from '../schedule-wbs-template';

export class ScheduleTemplateNameBase {
  ScheduleTemplateNameId: number;
  P6ProjectId: string;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectTemplates_ScheduleTemplateName?: Array<ProjectTemplate> | null;
  Schedules_ScheduleTemplateName?: Array<Schedule> | null;
  ScheduleWBSs_ScheduleTemplateName?: Array<ScheduleWBSs> | null;
  ScheduleWbsTemplates_ScheduleTemplateName?: Array<ScheduleWbsTemplate> | null;

  constructor(item?: IScheduleTemplateName) {
    if (item) {

      this.ScheduleTemplateNameId = item.ScheduleTemplateNameId;
      this.P6ProjectId = item.P6ProjectId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectTemplates_ScheduleTemplateName = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_ScheduleTemplateName);
      this.Schedules_ScheduleTemplateName = Helpers.createClassArray(Schedule, item.Schedules_ScheduleTemplateName);
      this.ScheduleWBSs_ScheduleTemplateName = Helpers.createClassArray(ScheduleWBSs, item.ScheduleWBSs_ScheduleTemplateName);
      this.ScheduleWbsTemplates_ScheduleTemplateName = Helpers.createClassArray(ScheduleWbsTemplate, item.ScheduleWbsTemplates_ScheduleTemplateName);
    }
  }
}